<template>
  <div class="panel the_solution">
    <div class="panel_title">{{ title }}</div>
    <div class="panel_body">
      <div class="nav_list">
        <ul>
          <li
            class="wow animate__animated animate__fadeInDown"
            v-for="(item, i) in list"
            :class="{ active: indexVal === item.value }"
            :style="{ 'animation-delay': i * 0.1 + 's' }"
            :key="item.value"
            @mouseenter="panel2NavHover(item.value)"
          >
            {{ item.value | filterIndustryType }}
          </li>
        </ul>
      </div>
      <div class="content_list">
        <ul>
          <li v-for="item in list" v-if="item.value === indexVal" :key="item.value">
            <div class="left wow animate__animated animate__fadeInLeft">
              <p>{{ item.text }}</p>
              <div class="btn" @click.stop="goPage(item)">查看更多</div>
            </div>
            <div class="right wow animate__animated animate__fadeInRight" v-if="item.img">
              <img :src="item.img" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { filterIndustryType } from "@/filters/dictionaryFilters";
import { INDUSTRY_TYPE } from "@/dictionary";
export default {
  name: "the_solution",
  filters: { filterIndustryType },
  data() {
    return {
      title: "解决方案",
      indexVal: "1",
      list: [
        {
          value: "1",
          text: "深度融入发展新能源汽车的国家战略大局，充分发挥吉利汽车省市两级产业链“链主”，和中航兰田、保罗汽车市级产业链“链核”企业的优势，围绕“能源燃料及造车原材料-零部件-系统总成-整车-配套基础设施”成链，打造新能源车产业链。以新能源汽车产业园为载体，突出吉利、美锦、中航兰田和保罗汽车等企业的龙头地位，形成乘用车、商用车、专用车三个整车产品线“一链三线”的战略布局;并积极引进整车、电机和电控等关键零部件、动力电池生产及回收等项目，推动更多上下游配套企业实现沿链聚合、融通发展。",
          img: require("@/assets/images/home/panel2_1.png"),
          moreUrl: "",
        },
        {
          value: "2",
          text: "响应制造强国战略号召，倾力打造以纺机、液压、煤机为主的装备制造产业链(群)。承接省、市高端装备制造产业链，发挥经纬智能、太重榆液市级产业链“链主”，方盛液压、多尔晋泽“链核”企业带动作用，锚定高端化、智能化、绿色化方向迈进。依托中南高科、保罗二期项目打造装备制造中小企业园，集聚区内外纺机、液压、煤机小微企业集中培育壮大，为产业稳步发展提供有力的继发优势；鼓励企业持续强化研发和技改推动技术创新，提升产品自动化、智能化、轻量化水平；支持企业在管理、产品、制造等各方面加大数字技术应用，建设智能生产线、智能车间和智能工厂，以全过程智能化、数字化、绿色化为标准打造“黑灯工厂”示范点，着力提升我区装备制造产业整体竞争力。",
          img: require("@/assets/images/home/panel2_2.png"),
          moreUrl: "",
        },
        {
          value: "3",
          text: "抢抓我国实施“健康中国”战略、从制药大国到制药强国跨越的历史机遇，围绕生物制药、化学药品、高端医疗器械、健康医疗服务等细分领域构建产业生态，健全研发、临床、制造、要素、生态和机制的全产业链支撑体系建设。重点支持德元堂发挥省级 “链核”企业优势，引领华卫制药、岐元堂等企业规模化发展，形成极具特色的中医药板块;依托振东安欣、宝泰药业、鑫煜制药等企业加大特色原料药和专利原料药开发力度，助力化学医药板块迈向价值链高端;以明鼎医药等企业为基础，以点带面引进一批生物制品企业，补齐生物制品短板。",
          img: require("@/assets/images/home/panel2_3.png"),
          moreUrl: "",
        },
        {
          value: "4",
          text: "把握国家致力于满足人民群众日益增长美好生活需要的重要契机，打造以深加工特色农产品、功能性零食、食醋及功能性醋饮品产业、高端品牌饮料、药膳及特膳功能食品等健康食品为主的现代食品产业集群。充分放大海玉食品市级产业链“链主”和北方功能食品产业园的引领效应，协同双合成、白象食品、康晋食品等一批优势企业共同夯实我区深加工特色农产品、功能性零食板块的“主业”根基；支持金龙鱼梁汾、东湖、恒顺等酿醋企业加大投资、扩产增效，打造食醋及功能性醋饮品产业板块。发挥娃哈哈、智悦等既有产能基础，加快中粮可口可乐项目落地建设进度，打造高端饮品生产基地；依托山西丰富的药食同源原料资源，探索打造药膳及特膳功能食品板块。",
          img: require("@/assets/images/home/panel2_4.png"),
          moreUrl: "",
        },
        {
          value: "5",
          text: "紧抓国家将新材料产业作为战略新兴产业基础与先导给予重点扶持的发展良机，重点打造以绿色建材、半导体材料、新型化学材料、新型金属材料等细分领域为主的新材料产业链(群)。发挥山西建投市级产业链“链主”，及绿建住品、凯德森“链核”企业优势，以山西建筑产业现代化(晋中)园众多链上企业为基础，着力引进新型墙体材料、建筑防水材料、隔热隔音材料、轻质建筑材料等生产企业，形成集研发、设计、生产、装配、服务“五位一体”的绿色建材产业链。支持中聚晶科等企业壮大生产规模，并重点引进单晶衬底、外延片、器材设计、器件制造等相关环节企业，做强半导体材料产业板块。支持天一纳米、科瀛科技、普丽环境、中海油贵金属等企业聚焦市场前沿，加大研发和技改力度，形成竞争优势明显的新型化学材料产业板块。以军昊实业声屏障材料为基础，积极引进高性能镁合金及变形镁合金、高性能铝及铝合金、镁合金锻件等生产项目，布局形成新型金属材料产业板块。",
          img: require("@/assets/images/home/panel2_5.png"),
          moreUrl: "",
        },
        {
          value: "6",
          text: "顺应数字化与信创化融合发展的风口趋势，着力打造以光伏电池及组件、信息创新软硬件及数字技术产业化为主的信息创新(数字经济)产业链(群)。发挥晋能光伏市级产业链“链主”企业优势，持续聚焦高效单晶、超高效异质结等高精尖技术方向，积极引进丝网印刷、PECVD设备、扩散炉、制绒设备及光伏玻璃等配套企业，打造光伏电池及组件产业链。构建以策源地集智创新、示范基地成果转化、三大园区场景应用的数字经济空间布局，形成覆盖基础研究、技术创新、成果转化、场景应用的信息创新（数字经济）产业链（群）。依托大学城高校园区优质资源，充分发挥各高校和相关数字经济创新载体的创新引领作用。打造“数字经济创新策源地”；依托智创城NO.4基地等7个省级、市级双创基地，打造百家重点企业聚集、千家小微企业协同发展的“数字经济产业示范基地”；在新能源、汇通和潇河产业园区内筛选一批具备条件的优质企业，率先面向智慧交通、智慧园区、智慧工厂、智慧车间等领域，高标准打造应用示范场景。依托工业互联网数字化转型促进中心，以液压行业整体数字化赋能为试点和蓝本，建立集企业服务、工业品采购交易、信息共享、进出口贸易等为一体的产业互联网平台。",
          img: require("@/assets/images/home/panel2_6.png"),
          moreUrl: "",
        },
        {
          value: "7",
          text: "建设现代流通体系是构建新发展格局的一项重要战略任务，充分利用我区处于太原都市圈核心区的区位优势和已形成的物流产业基础，抢抓机遇、乘势而上，打造现代物流产业链(群)。进一步完善与产业布局、消费格局相适应的大宗货物、集装箱物流网络，大力发展货物多式联运。依托中鼎物流、中储物流、苏宁物流、普洛斯物流和安物流等企业形成的集聚效应、吸附效应和吞吐能力，进一步加大招引力度，优选国内外知名大型物流企业在我区设立基地，推动道路货运高质量发展;发挥中鼎物流始发站的优势做大中欧班列吞吐量，有序壮大铁路集装箱运输;以武宿机场三期建设项目为切入点，支持并协助区属物流企业有效对接，做强航空货运板块。加快山西佳德海峡两岸电商(跨境)产业园和阿里菜鸟华北零售供应链基地等在谈项目落地建设进度,有力提升我区物流产业精化、规模化水平。",
          img: require("@/assets/images/home/panel2_7.png"),
          moreUrl: "",
        },
      ],
    };
  },
  methods: {
    panel2NavHover(title) {
      if (this.indexVal !== title) this.indexVal = title;
    },
    goPage(tar) {
      if (tar && tar.moreUrl) {
        this.$router.push({ path: tar.moreUrl });
      } else {
        this.$router.push({ path: "/exhibition-hall/solution", query: { types: tar.value } });
      }
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
